(() => {
  const root = document.querySelector('[data-miis-home]');
  if (!root) return;

  const price = 169900;
  const productHandle = root.dataset.productHandle || 'novenario-de-adviento-hello-kitty-and-friends';
  const numericVariantId = Number(root.dataset.variantId || 0);
  const isBlocked = root.dataset.blocked === 'true';
  const saleStart = new Date(root.dataset.saleStart).getTime();
  const saleEnd = new Date(root.dataset.saleEnd).getTime();
  let isAvailable = root.dataset.saleReady === 'true';
  let hasAddedToCart = false;

  const formatMoney = (value) =>
    new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    }).format(value).replace('COP', '$');

  const qtyInputs = [...root.querySelectorAll('[data-miis-qty]')];
  const totals = [...root.querySelectorAll('[data-miis-total]')];
  const buyButtons = [...root.querySelectorAll('[data-miis-buy]')];
  const status = root.querySelector('[data-miis-status]');

  const syncQty = (value) => {
    const qty = Math.min(5, Math.max(1, parseInt(value || '1', 10)));
    qtyInputs.forEach((input) => { input.value = qty; });
    totals.forEach((element) => { element.textContent = formatMoney(price * qty); });
    root.querySelectorAll('[data-miis-step="1"]').forEach((button) => { button.disabled = qty >= 5; });
    root.querySelectorAll('[data-miis-step="-1"]').forEach((button) => { button.disabled = qty <= 1; });
    return qty;
  };

  root.querySelectorAll('[data-miis-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const current = parseInt(qtyInputs[0]?.value || '1', 10);
      syncQty(current + parseInt(button.dataset.miisStep || '0', 10));
    });
  });

  qtyInputs.forEach((input) => {
    input.addEventListener('change', () => syncQty(input.value));
  });
  syncQty(1);

  buyButtons.forEach((button) => {
    button.dataset.originalLabel = button.innerHTML;
  });

  const updatePurchaseState = () => {
    root.dataset.saleReady = isAvailable ? 'true' : 'false';
    buyButtons.forEach((button) => {
      if (isBlocked) {
        button.disabled = true;
        button.textContent = 'Exclusivo detal';
        return;
      }

      if (isAvailable) {
        button.disabled = false;
        button.innerHTML = hasAddedToCart ? 'PAGAR AHORA' : (button.dataset.originalLabel || 'Agregar al carrito');
        return;
      }

      button.disabled = true;
      button.textContent = 'NO DISPONIBLE';
    });
  };

  let availabilityTimer = null;
  let availabilityInFlight = false;

  const nextAvailabilityDelay = () => {
    const base = isAvailable ? 25000 : 8000;
    const jitter = Math.floor(Math.random() * (isAvailable ? 5000 : 2000));
    return base + jitter;
  };

  const scheduleAvailabilityCheck = () => {
    window.clearTimeout(availabilityTimer);
    if (document.hidden) return;
    availabilityTimer = window.setTimeout(async () => {
      await refreshAvailability();
      scheduleAvailabilityCheck();
    }, nextAvailabilityDelay());
  };

  const refreshAvailability = async () => {
    if (!productHandle || !numericVariantId || availabilityInFlight) return;
    availabilityInFlight = true;
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'products/' + encodeURIComponent(productHandle) + '.js?inventory_check=' + Date.now(), {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;

      const productJson = await response.json();
      const liveVariant = Array.isArray(productJson.variants)
        ? productJson.variants.find((variant) => Number(variant.id) === numericVariantId)
        : null;

      if (liveVariant) {
        isAvailable = Boolean(liveVariant.available);
        updatePurchaseState();
      }
    } catch (error) {
      // Conserva el último estado válido y vuelve a consultar en el siguiente ciclo.
    } finally {
      availabilityInFlight = false;
    }
  };

  const countdown = root.querySelector('[data-miis-countdown]');
  const countdownTitle = root.querySelector('[data-miis-countdown-title]');
  const countdownUnits = countdown ? [...countdown.querySelectorAll('[data-miis-unit]')] : [];

  const renderCountdown = () => {
    if (!countdown) return;

    const now = Date.now();
    let target = saleStart;

    if (now < saleStart) {
      if (countdownTitle) countdownTitle.innerHTML = 'Preventa<br>inicia en';
      target = saleStart;
    } else if (now <= saleEnd) {
      if (countdownTitle) countdownTitle.innerHTML = 'Preventa<br>termina en';
      target = saleEnd;
    } else {
      if (countdownTitle) countdownTitle.innerHTML = isAvailable ? 'Preventa<br>finalizada' : 'No<br>disponible';
      target = now;
    }

    let ms = Math.max(0, target - now);
    const days = Math.floor(ms / 86400000);
    ms %= 86400000;
    const hours = Math.floor(ms / 3600000);
    ms %= 3600000;
    const minutes = Math.floor(ms / 60000);
    ms %= 60000;
    const seconds = Math.floor(ms / 1000);

    [days, hours, minutes, seconds].forEach((value, index) => {
      if (countdownUnits[index]) countdownUnits[index].textContent = String(value).padStart(2, '0');
    });
  };

  renderCountdown();
  updatePurchaseState();
  refreshAvailability().finally(scheduleAvailabilityCheck);

  window.setInterval(renderCountdown, 1000);

  window.addEventListener('focus', async () => {
    await refreshAvailability();
    scheduleAvailabilityCheck();
  });
  document.addEventListener('visibilitychange', async () => {
    if (document.hidden) {
      window.clearTimeout(availabilityTimer);
      return;
    }
    await refreshAvailability();
    scheduleAvailabilityCheck();
  });

  buyButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      if (isBlocked) {
        if (status) status.textContent = 'Esta preventa es exclusiva para clientes al detal.';
        return;
      }

      if (!numericVariantId) return;

      if (hasAddedToCart) {
        window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
        return;
      }

      await refreshAvailability();
      if (!isAvailable) {
        updatePurchaseState();
        if (status) status.textContent = 'En este momento no hay unidades disponibles.';
        scheduleAvailabilityCheck();
        return;
      }

      const qty = syncQty(qtyInputs[0]?.value || 1);
      buyButtons.forEach((item) => { item.disabled = true; });

      try {
        if (!window.MiisAdvientoCart || typeof window.MiisAdvientoCart.addAndOpen !== 'function') {
          throw new Error('El carrito no está listo. Intenta nuevamente.');
        }

        await window.MiisAdvientoCart.addAndOpen({
          variantId: numericVariantId,
          quantity: qty,
          focusElement: button
        });

        hasAddedToCart = true;
        buyButtons.forEach((item) => { item.disabled = false; });
        updatePurchaseState();
      } catch (error) {
        if (status) {
          status.textContent = error?.shopify?.description || error?.message || 'No fue posible agregar el producto. Verifica la disponibilidad e intenta nuevamente.';
        }
        await refreshAvailability();
        updatePurchaseState();
      }
    });
  });
})();